import React from 'react';
import {
  LinkStyled, Heading1, Paragraph, Heading2, List, Heading4,
} from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Alkohol" activeSidemenu="Daaseoel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Dåseøl</Heading1>
          <Paragraph>
            Er du på jagt efter en forfriskende klassisk dåseøl? Hos Skafte finder du billige dåseøl, der leveres direkte til døren eller hvor du ønsker, så du slipper for den lange tur over grænsen. Du finder de klassiske varianter, såsom Tuborg dåseøl og Carlsberg dåseøl, men du finder desuden også mere specielle varianter, så der er noget for enhver smag. Uanset om dåseøllen skal understøtte en god middag, en søndag eftermiddag eller være med til julefrokosten, så har vi en variant, der passer perfekt.
          </Paragraph>
          <Paragraph>
            Leder du efter øl på dåse, er du havnet det helt rigtige sted. Skal det gerne klirre, når du skåler, finder du også et stort udvalg af <LinkStyled to="/oel/flaskeoel">flaskeøl</LinkStyled>.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="daaseoel" showType showAlcPct display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Stort udvalg af dåseøl</Heading2>
          <Paragraph>
            Hos Skafte finder du et kæmpe sortiment af dåseøl til en god pris.
            Vi tilbyder det bedste til ganen og du finder således både de klassiske dåseøl, men også nogle af de lidt mere særlige varianter.
          </Paragraph>
          <Paragraph>
            Blandt udvalget kan du eksempelvis gå på udkig blandt:
          </Paragraph>
          <List>
            <li>Grøn Tuborg dåseøl</li>
            <li>Carlsberg dåseøl</li>
            <li>Tuborg Classic dåseøl</li>
            <li>Carl’s Special dåseøl</li>
            <li>Carlsberg 1883 dåseøl</li>
            <li>Tuborg Julebryg på dåse (sæson)</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Billige dåseøl med god samvittighed</Heading2>
          <Paragraph>
            Er du typen der godt kan lide at købe flere rammer dåseøl af gangen? Så er der en god grund til at købe stort ind hos Skafte, frem for at tage den lange tur over den tyske grænse. En køretur, der desuden er skidt for vores allesammens miljø.
          </Paragraph>
          <Paragraph>
            Hos Skafte har vi, modsat i Tyskland, pantmærker på vores dåseøl pr. dansk lovkrav, hvilket betyder, at du med god samvittighed kan købe billige dåseøl med rigtig god samvittighed - også selvom du køber større mængder. Både pantmærket og den sparede køretur til grænsehandlen er nemlig godt for miljøet.
            Så tag en tår af en iskold dåseøl og læn dig tilbage med god samvittighed.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>3 fordele ved at købe dåseøl</Heading2>
          <Paragraph>
            Når det kommer til øl, har vi alle vores præferencer. Nogle sværger til øl på flaske, andre til øl fra fad, men i de senere år har dåseøl oplevet en enorm stigning i popularitet. Men hvorfor er det sådan? Nedenfor finder du tre fordele ved at vælge dåseøl frem for andre varianter.
          </Paragraph>
          <Heading4>
            Praktisk og transportabel
          </Heading4>
          <Paragraph>
            Dåseøl er utrolig praktiske. Dåser er nemlig lette at bære, hvilket gør dem til det perfekte valg til picnic, strandture, festivaler eller bare en tur i parken. I modsætning til flaskeøl er de også mere robuste og mindre tilbøjelige til at gå i stykker, hvis de tabes.
            Desuden er dåseøl også lette at opbevare, da både øl og rammer let kan stables.
          </Paragraph>
          <Heading4>
            God holdbarhed
          </Heading4>
          <Paragraph>
            Dåseøl er næsten helt lufttætte og blokerer al lys, hvilket gør dem formidable til at bevare øllets friskhed og smag. Lys og luft er nemlig de to største fjender af øl, da de kan fremskynde oxidation og forringe smagen. Flasker, selv de mørke, kan tillade en lille mængde lys igennem, og fadøl kan blive påvirket af luft, når det først er tappet.
            Så hvis du ønsker den ultimative holdbarhed og friskhed i din øl, bør du derfor overveje at vælge dåseøl frem for andre varianter.
          </Paragraph>
          <Heading4>
            Materialet
          </Heading4>
          <Paragraph>
            Grundet materialet, vejer dåseøl betydeligt mindre end flasker og er derfor både lette at bære og transportere. Selv i større mængder.
            Derudover er aluminium et materiale, der er yderst let at genanvende.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Dåseøl til private og erhverv</Heading2>
          <Paragraph>
            Hvad er bedre end at åbne en kold dåseøl efter en lang dag, eller at tilbyde en lækker, kølig øl til dine kunder og kolleger til fredagsbaren? Skafte har nøjagtig hvad du har brug for, uanset om du køber dåseøl til privat brug eller til din virksomhed.
          </Paragraph>
          <Paragraph>
            For private kunder tilbyder Skafte et bredt udvalg af dåseøl. Vi har noget for enhver smag - fra klassiske pilsnere til de lidt mere særlige. Og det bedste er, at vi gør det nemt for dig. Du kan bestille direkte fra vores hjemmeside og få dine dåseøl leveret direkte til din hoveddør, så du altid har din favoritøl i køleskabet; kolde og klar til når du har lyst til en.
          </Paragraph>
          <Paragraph>
            Er du erhvervskunde? Skafte har dig også dækket her. Vi leverer til flere virksomheder, foreninger mm. - også som fast levering, så I er sikre, at der altid er kolde dåseøl på lager til fredagsbaren, events, fester og lignende.
            Du kan let vælge at se priserne uden moms, ved at klikke oppe i højre hjørne og vælge “uden moms”.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
